import { EnvironmentModel } from '@env/environment.model';

export const environment: EnvironmentModel = {
  env: 'dev',
  production: false,
  apiUrl: 'https://cpba-dv.nmfta.org/',
  oktaIssuer: 'https://nmfta.okta.com/oauth2/default',
  clientId: '0oa10v4g2neUprwMj698', //dev
  debug: true,
  enableIndexedDB: true,
};
